export default __webpack_public_path__ + "static/media/developers-eth-blocks.009fef1c.webp";